import axios from 'axios';

export default function postUrlFileUpload(acceptedFiles, keyString, params, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postVinFileUpload;

    const data = {
        key: keyString,
        bucket: params.bucket,
        method: params.method,
        metadata: params.fields
    }

    const respData = new FormData();

    return dispatch => dispatch({
        type: 'VIN_FILE_UPLOAD_FETCH',
        payload: axios({ method: 'post', url, headers, data }).then((response) => {
            // now do a PUT request to the pre-signed URL
            console.log(response)
            Object.keys(response.data.url.fields).forEach(field => respData.append(field, response.data.url.fields[field]));
            respData.append('bucket', params.bucket);
            respData.append('file', acceptedFiles[0]);

            const headersPreSigned = {};
            Object.keys(response.data.url.fields).filter((field) => {
                if (field.includes('x-amz-meta')) {
                    headersPreSigned[field] = response.data.url.fields[field];
                }
            });            

            const urlPresigned = response.data.url.url;
            axios({ method: 'POST', url: urlPresigned, headers: headersPreSigned, data: respData }).then((resp) => {
                console.log(resp);
            }).catch((e) => {
                console.log(e);
            });
        })
    });
}


// WEBPACK FOOTER //
// ./src/actions/postUrlFileUpload.js